import { LitElement, css, html, unsafeCSS } from "lit";
import { template } from "./template";
import styles from "./styles.css?inline";
import { customElement } from "lit/decorators.js";
import { connectedProperty } from "../../../../infrastructure/state/connected-property";
import { activityHistorySearchStringSelector } from "../../../search/selectors";
import { areCustomFiltersActive } from "../../custom-filters/selectors";
import { areCommonFiltersActive } from "../../common-filters/selectors";
import { areDiagnosticFiltersActive } from "../../diagnostic-filters/selectors";
import { areUpFiltersActive } from "../../up-filters/selectors";

//@ts-ignore
@customElement("active-filters-header")
export class ActiveFiltersHeader extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
    ${unsafeCSS(styles)}
  `;

  @connectedProperty(activityHistorySearchStringSelector)
  searchString: string;

  @connectedProperty(areCustomFiltersActive)
  areCustomFiltersActive: boolean;

  @connectedProperty(areCommonFiltersActive)
  areCommonFiltersActive: boolean;

  @connectedProperty(areDiagnosticFiltersActive)
  areDiagnosticFiltersActive: boolean;

  @connectedProperty(areUpFiltersActive)
  areUpFiltersActive: boolean;
}
